const MAX_ROLE_PORTRAIT_FILE_SIZE = 10 * 1024 * 1024;
const ROLE_PORTRAIT_IMAGE_TYPES = ["image/jpeg", "image/png"];

const getRolePortraitFileError = (file) => {
    if (!file) return "请选择照片";
    if (ROLE_PORTRAIT_IMAGE_TYPES.indexOf(file.type) === -1) return "照片仅支持 JPG 或 PNG 格式";
    if (file.size > MAX_ROLE_PORTRAIT_FILE_SIZE) return "照片文件不能超过 10MB";
    return "";
};

const getRolePortraitDimensionError = ({ width, height } = {}) =>
    Number(width) < 600 || Number(height) < 600 ? "图片尺寸不能小于 600 × 600" : "";

module.exports = {
    MAX_ROLE_PORTRAIT_FILE_SIZE,
    getRolePortraitDimensionError,
    getRolePortraitFileError,
};
